import moment from "moment";
import { contains, filter, forEach } from "ramda";
import { AccountComments, Comment, CommentsByPeriod } from "./types";

export const formatTimestampForComments = (timestamp: number): string => {
  const differenceInMinutes = moment().diff(moment(timestamp), "minutes");
  if (differenceInMinutes < 1) {
    return "Just Now";
  }
  if (differenceInMinutes < 60) {
    return differenceInMinutes + " min ago";
  }
  const differenceInHours = moment().diff(moment(timestamp), "hours");
  if (differenceInHours < 24) {
    return (
      differenceInHours + " " + pluralize(differenceInHours, "hour") + " ago"
    );
  }
  const differenceInDays = moment().diff(moment(timestamp), "days");
  if (differenceInDays < 7) {
    return differenceInDays + " " + pluralize(differenceInDays, "day") + " ago";
  }
  return moment
    .utc(timestamp)
    .local()
    .format("MMM DD YYYY");
};

const pluralize = (num: number, stringToPluralize: string): string => {
  return num > 1 ? stringToPluralize + "s" : stringToPluralize;
};

export const sortCommentsByAccount = (comments: Comment[]): AccountComments => {
  const accountComments: AccountComments = {};
  forEach((comment: Comment) => {
    if (!comment.accountId) {
      return;
    }
    if (!accountComments[comment.accountId]) {
      accountComments[comment.accountId] = [comment];
    } else {
      accountComments[comment.accountId].push(comment);
    }
  }, comments);
  return accountComments;
};

export const sortCommentsByPeriod = (comments: Comment[]): CommentsByPeriod => {
  const spreadComments: CommentsByPeriod = {};

  forEach((comment: Comment) => {
    if (!comment.period || comment.accountId) {
      return;
    }

    if (!spreadComments[comment.period]) {
      spreadComments[comment.period] = [comment];
    } else {
      spreadComments[comment.period].push(comment);
    }
  }, comments);

  return spreadComments;
};

export const sortAccountCommentsByPeriod = (
  comments: Comment[]
): CommentsByPeriod => {
  const spreadComments: CommentsByPeriod = {};

  forEach((comment: Comment) => {
    if (!comment.period || !comment.accountId) {
      return;
    }

    if (!spreadComments[comment.period]) {
      spreadComments[comment.period] = [comment];
    } else {
      spreadComments[comment.period].push(comment);
    }
  }, comments);

  return spreadComments;
};

export const getUnreadComments = (comments: Comment[], userId: string) =>
  filter(
    (comment: Comment) => !comment.readBy || !contains(userId, comment.readBy),
    comments
  );

export const isCommentUnread = (comment: Comment, userId: string) =>
  comment.readBy != null &&
  comment.readBy.length > 0 &&
  !contains(userId, comment.readBy);

export const getSpreadComments = (comments: Comment[]) =>
  filter((comment: Comment) => !comment.accountId, comments);



// WEBPACK FOOTER //
// ./src/commentView/helpers.ts